import React, { Component, Fragment } from 'react';
import classNames from 'classnames';
import { addToObject } from '../../utils/immutable';
import './styles.styl';
import icons from '../../assets/comet/comet.svg';

class CompleteSentence extends Component {
  constructor(props) {
    super(props);

    props.setReviewSheet(this.renderReviewChunk);
  }

  feedback = (choice, userChoice, correctAnswer, isValidated) => {
    if (isValidated && choice === userChoice && this.props.isFinalAttempt) {
      return correctAnswer === userChoice;
    }
  };

  choiceStyle = (choice, input, sentenceIndex, isValidated) => {
    if (input) {
      return classNames('complete-sentence__choice', {
        'complete-sentence__choice--selected': choice === input[sentenceIndex],
        'complete-sentence__choice--success': this.feedback(
          choice,
          input[sentenceIndex],
          this.props.correctInput[sentenceIndex],
          isValidated
        ),
        'complete-sentence__choice--error':
          this.feedback(
            choice,
            input[sentenceIndex],
            this.props.correctInput[sentenceIndex],
            isValidated
          ) === false
      });
    } else {
      return 'complete-sentence__choice';
    }
  };

  handleChoiceClick = (choice, index, isValidated) => {
    if (!isValidated) {
      const payload = addToObject(this.props.input, index, choice);
      this.props.onInput(payload);
      const readyToSubmit =
        Object.keys(payload).length === this.props.data.length;
      this.props.setSubmitStatus(readyToSubmit);
    }
  };

  renderReviewChunk = () => {
    const { question, data, correctInput } = this.props;
    return (
      <Fragment>
        <p className="review-question">{question}</p>
        {data.map((sentence, sentenceIndex) => {
          return (
            <Fragment key={sentenceIndex}>
              <p className="review-option">
                {sentence.beforeChoice} [
                {sentence.choices.map((choice, index) => {
                  if (index === sentence.choices.length - 1) {
                    return <span key={index}>{choice}</span>;
                  } else {
                    return <span key={index}>{choice}, </span>;
                  }
                })}
                ]&nbsp;
                {sentence.afterChoice}
              </p>
              <p className="review-correct">
                Correct Answer: {correctInput[sentenceIndex]}
              </p>
            </Fragment>
          );
        })}
      </Fragment>
    );
  };

  render() {
    const { validationResult, input, correctInput, data } = this.props;

    const isValidated = validationResult !== null;

    return (
      <Fragment>
        {data.map((sentence, sentenceIndex) => {
          return (
            <p key={sentenceIndex}>
              {sentence.beforeChoice}
              {sentence.choices.map((choice, choiceIndex) => {
                return (
                  <button
                    key={choiceIndex}
                    onClick={() =>
                      this.handleChoiceClick(choice, sentenceIndex, isValidated)
                    }
                    className={this.choiceStyle(
                      choice,
                      input,
                      sentenceIndex,
                      isValidated
                    )}
                  >
                    {choice}
                    {isValidated && (
                      <span className="validation-indicator">
                        <svg
                          className="comet-form__checkbox-checked-icon"
                          aria-hidden="true"
                          focusable="false"
                        >
                          <use
                            xlinkHref={`${icons}#${
                              this.feedback(
                                choice,
                                input[sentenceIndex],
                                correctInput[sentenceIndex],
                                isValidated
                              )
                                ? 'check'
                                : 'x'
                            }`}
                          />
                        </svg>
                      </span>
                    )}
                  </button>
                );
              })}
              {sentence.afterChoice}
            </p>
          );
        })}
      </Fragment>
    );
  }
}

export default CompleteSentence;



// WEBPACK FOOTER //
// ../core/src/components/CompleteSentence/CompleteSentence.js